/**
 * Refetches caused by stream events go through here, coalesced per query client (core/coalesce.ts): a burst of events
 * refetches each matching query once, not once per event. A person's own writes still invalidate at once (their
 * mutations call invalidateQueries directly).
 */
import type { QueryClient } from '@tanstack/react-query';
import { createCoalescer, type Coalescer, type Key } from './coalesce';

const byClient = new WeakMap<QueryClient, Coalescer>();

export function invalidateSoon(qc: QueryClient, queryKey: Key) {
  let c = byClient.get(qc);
  if (!c) {
    c = createCoalescer((keys) => {
      for (const k of keys) void qc.invalidateQueries({ queryKey: k });
    });
    byClient.set(qc, c);
  }
  c.add(queryKey);
}
